import { Config } from "@/utils/config.utils";

import { MAX_STORES_LIST } from "../storeSearch.config";
import { enrichStores } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";

export const findStoresByLatLng = async (
    StoresService: woosmap.map.StoresService,
    DistanceService: woosmap.map.DistanceService,
    storeUrls: Array<StoreUrl>,
    tags: Array<string>,
    latLng: woosmap.map.LatLngLiteral,
    radius?: number
) => {
    const query = [
        `user.locale:="${Config.getLocale()}"`,
        ...tags.map((tag) => `tag:"${tag}"`)
    ].join(" AND ");

    const storesResponse = await StoresService.search({
        storesByPage: MAX_STORES_LIST,
        query: query,
        latLng: latLng,
        radius: radius
    });

    const stores = enrichStores(
        storesResponse.features ?? [],
        storeUrls,
        latLng,
        DistanceService
    );

    return {
        stores: stores,
        query: query
    };
};
